import { Search, Close } from '@mui/icons-material';
import { SxProps } from '@mui/material';
import { TextField } from 'common/form/components/TextField';
import { useState } from 'react';

type SearchInputProps = {
  sx?: SxProps;
  placeholder?: string;
  defaultValue?: string;
  onChange: (value: string) => void;
};

export const SearchInput = ({
  sx,
  placeholder = 'Search',
  defaultValue,
  onChange
}: SearchInputProps) => {
  const [searchQuery, setSearchQuery] = useState(defaultValue ?? '');

  const handleChange = (value: string) => {
    setSearchQuery(value);
    onChange(value);
  };

  return (
    <TextField
      field={{
        containerSx: sx,
        placeholder,
        startIcon:
          searchQuery.length <= 0 ? (
            <Search data-testid="search-input-search-icon" fontSize="small" />
          ) : (
            <Close
              data-testid="search-input-close-icon"
              fontSize="small"
              color="primary"
              sx={{ cursor: 'pointer' }}
              onClick={() => handleChange('')}
            />
          )
      }}
      value={searchQuery}
      onChange={handleChange}
    />
  );
};
